export default __webpack_public_path__ + "static/media/background-image_5.f6a06813.jpg";